import React from 'react'

import PropTypes from 'prop-types'

import { ContextHeadline } from '@aok/text-elements'
import { PrimaryButton } from '@aok/ui-elements'

import { getHeadlineText } from '../../../../utils/TextUtils'
import defaultProps from '../../../../utils/propTypes/defaultProps'

const M047Introduction = ({ headline, text, startButtonTitle, navigateToNextPage }) => {
  return (
    <div className="w-full px-16 720:px-24 1000:w-3/4 1000:px-0 mx-auto">
      <ContextHeadline
        text={getHeadlineText(headline, 'text-07983e')}
        className="
                text-24 leading-32 text-005e3f text-center
                font-semibold font-buenos-aires"
      />
      <p className="mt-24 text-center">{text}</p>
      <PrimaryButton onClick={navigateToNextPage} className="mt-40 mx-auto">
        {startButtonTitle}
      </PrimaryButton>
    </div>
  )
}

M047Introduction.propTypes = {
  headline: PropTypes.shape({
    tag: PropTypes.string,
    text: PropTypes.string,
    placeholder: PropTypes.shape({
      text: PropTypes.string,
    }),
  }),
  text: PropTypes.string,
  startButtonTitle: PropTypes.string,
  navigateToNextPage: PropTypes.func,
}

M047Introduction.defaultProps = {
  headline: {
    tag: 'h4',
    text: defaultProps.HEADLINE_WITH_PLACEHOLDER,
  },
  text: defaultProps.TEXT,
  startButtonTitle: defaultProps.TEXT,
}

export default M047Introduction
